<script lang="ts" setup>
import type { HeroContainerProps } from '@nimbus/types'
import { isEmpty } from 'es-toolkit/compat'
import type { Game, GameClickEventEmit } from '@game/types'
import { computed } from '#imports'

const props = defineProps<HeroContainerProps>()
const emit = defineEmits<GameClickEventEmit>()

const content = computed(() => {
    if (isEmpty(props.data)) return null

    const preparedContent = {
        ...props.data,
    }

    /**
     * checkUspList is a temporary function made to fix missing string array data in the usp_list prop
     * Once content.usp_list is an array of strings, this can be deleted
     */
    const uspList = []
    if (preparedContent?.usp_1) uspList.push(preparedContent.usp_1)
    if (preparedContent?.usp_2) uspList.push(preparedContent.usp_2)
    if (preparedContent && uspList.length) preparedContent.usp_list = uspList

    return preparedContent
})
</script>

<template>
    <div class="hero__container">
        <div v-if="isEmpty(content)" class="hero" />
        <NimbusHeroGame
            v-else
            :key="content.game_slug"
            :content="content"
            :preset="preset"
            @game-click="(game: Game) => emit('game-click', game)"
        />
    </div>
</template>

<style lang="scss" scoped>
.hero__container {
    display: flex;
    overflow: hidden;
    min-height: 318px;
    padding: 0 15px;

    @include tablet(md) {
    }

    // SCSS-variables replaced with clear numbers
    // to enhance readability 8)
    @media (min-width: 360px) {
        min-height: 375px;
    }

    @media (min-width: 375px) {
        min-height: 384px;
    }

    @media (min-width: 414px) {
        min-height: 408px;
    }

    @media (min-width: 430px) {
        min-height: 418px;
    }

    @media (min-width: 600px) {
        min-height: 522px;
    }

    @include tablet(md) {
        min-height: 344px;
        padding: 0 30px;
    }
}

.hero {
    width: 100%;
    background-color: $hero-skeleton-color;
    border-radius: var(--border-radius, $border-radius);
}
</style>
